/*eslint-disable*/
import { request} from '../../utils/request/request'
export function getRechargeTotal(query){
    return request({
        url:'api/fee/v1/Prepays',
        method:'get',
        params:query
    })
}
export function queryRecharge(query){
    return request({
        url:'api/fee/v1/Prepays',
        method:'get',
        params:query
    })
}
